import {CsvModel} from "../../util/CSVWriteUtil";
import {HoodItem, SeatingPlanModel} from "./SeatingPlanModel";
import {dfsSequence, HierarchyEmployee, HierarchyRoot} from "../../util/EmployeeHierarchy";

export type ExportEmployeeRow = {
    employee: HierarchyEmployee,
    oldHoods: HoodItem[],
    newHoods: HoodItem[],
}

const employeeCsvModel = new CsvModel<ExportEmployeeRow>([
    {
        header: 'Name',
        value: row => row.employee.fullName,
    },
    {
        header: 'Team',
        value: row => (row.employee.teamPath || []).map(t => t.name).join(' / '),
    },
    {
        header: 'Old Neighbourhood',
        value: row => row.oldHoods.map(hood => hood.originalProps?.name || hood.name).join(', '),
    },
    {
        header: 'New Neighbourhood',
        value: row => row.newHoods.map(hood => hood.name).join(', '),
    },
]);

export function downloadMovedEmployeesCsv(model: SeatingPlanModel, filteredHierarchy: HierarchyRoot) {
    const rows: ExportEmployeeRow[] = [];

    for (const employee of dfsSequence(filteredHierarchy)) {
        if (employee.type === 'node' && employee.match && !employee.deactivated) {
            rows.push({
                employee: employee,
                oldHoods: model.originalEmployeeNeighbourhood.get(employee),
                newHoods: model.modifiedEmployeeNeighbourhood.get(employee),
            });
        }
    }

    const date = new Date();
    employeeCsvModel.downloadCsv(
        `seating_plan_employees_${date.toISOString()}.csv`,
        rows,
    );
}
